// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3LWLP","info":"Note_info__1Nfop","note":"Note_note__3y0cu","actions":"Note_actions__3xIlk"};